import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ProductSort } from '../../services';

export const fetchProductSort = createAsyncThunk(
    'productSort/fetchProductSort',
    async ({ id, sort }) => {
        const response = await ProductSort(id, sort)
        return response.result
    }
)

const productSortSlice = createSlice({
    name: 'productSort',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductSort.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductSort.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchProductSort.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default productSortSlice.reducer;
